import {
  MdBadge,
  MdSupervisorAccount,
  MdChat,
  MdDescription,
  MdMonetizationOn,
  MdSettings,
  MdOutlineCollectionsBookmark,
  MdBuild,
  MdCardGiftcard,
} from 'react-icons/md';
import { NavElement } from '../../../type';
import routes from '../../../routes';

export const navElementList: NavElement[] = [
  {
    route: routes.pages.consumers(),
    icon: MdSupervisorAccount,
    title: 'Clients',
    closed: false,
  },
  {
    route: routes.pages.messagesPage(),
    icon: MdChat,
    title: 'Messages',
    closed: false,
  },
  {
    route: routes.pages.invoicments(),
    icon: MdDescription,
    title: 'Invoices',
    closed: false,
  },
  {
    route: routes.pages.referralRewardsPage(),
    icon: MdCardGiftcard,
    title: 'Referrals',
    // apisupport lets an admin look through the rewards, not a plain user
    closed: true,
  },
  {
    route: routes.pages.tariffsPage(),
    icon: MdMonetizationOn,
    title: 'Tariffs',
    closed: false,
  },
  {
    route: routes.pages.toolsPage(),
    icon: MdBuild,
    title: 'Tools',
    closed: false,
  },
  {
    route: routes.pages.logsPage(),
    icon: MdOutlineCollectionsBookmark,
    title: 'Logs',
    closed: true,
  },
  {
    route: routes.pages.users(),
    icon: MdBadge,
    title: 'Employees',
    closed: false,
  },
  {
    route: routes.pages.applicationSettingsPage(),
    icon: MdSettings,
    title: 'Settings',
    closed: false,
  },
];
